import { render } from "./AddNote.vue?vue&type=template&id=db3b3482&ts=true"
import script from "./AddNote.vue?vue&type=script&lang=ts"
export * from "./AddNote.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__